module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0038.jpg?v=f699177e";